<template>
  <div id="">
      <a href="#/usuarios" @click="maisInfs" v-if="!showMaisInfs">Mais Infs.</a>
      <p v-else>
         {{ numPacientes }} Pacientes (Incluindo os excluídos)
      </p>
  </div>
</template>
<script>
export default {
  name: "",

  props:{
    userId : 0
  },

  data(){
    return{
      showMaisInfs: false,
      numPacientes: 0
    }
  },

  methods: {
    maisInfs() {
      axios.get('/api/usuario-mais-infos-json/' + this.userId).then(({data}) => {
        this.numPacientes = data
        console.log(data);
        this.showMaisInfs = true
      });
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
